import * as React from 'react'
import classnames from 'classnames'

export type IconSize =
    | 'xxsmall'
    | 'xsmall'
    | 'small'
    | 'smedium'
    | 'medium'
    | 'large'
    | 'xlarge'

type IconProps = React.PropsWithChildren & {
    name: string
    size?: IconSize
    className?: string
}

export const Icon: React.FC<IconProps> = (props) => {
    const { name } = props
    const size = props.size ?? 'medium'
    const sizeClassMap: Record<IconSize, string> = {
        xxsmall: 'text-icon-xxsmall',
        xsmall: 'text-icon-xsmall',
        small: 'text-icon-small',
        smedium: 'text-icon-smedium',
        medium: 'text-icon-medium',
        large: 'text-icon-large',
        xlarge: 'text-icon-xlarge',
    }
    const sizeClass = sizeClassMap[size]
    const className = classnames(
        'material-symbols-rounded',
        sizeClass,
        props.className
    )
    return (
        <span data-testid={`${name}-icon`} className={className}>
            {name}
        </span>
    )
}
